import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
// import OutsideClickHandler from "react-outside-click-handler";
import {
  getSingleUser,
  changeUserStatus,
  getGuarantorData,
  approveGuarantors,
  rejectGuarantors,
  rejectGuarantorOne,
  rejectGuarantorTwo,
  changePaymentStatus,
  getSingleWeb3User
} from "../../lib/data";
import ReactToPrint from "react-to-print";

import arrow from "../../images/svg/arrow-back.svg";
import arrow2 from "../../images/svg/arrow-down.svg";
import arrow3 from "../../images/svg/arrow-dwn-purple.svg";
import download from "../../images/svg/download.svg";
import Loader from "../Loader";
import paymentMode from '../../images/payment-mode.png' 
import axios from "axios";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";

function WaitlistDetails() {
  const [clicked, setClicked] = useState("bio");
  const [guarantorDetails, setGuarantorDetails] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [changeStatus, setChangeStatus] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [downloadHtml, setDownloadHtml] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const user_id = urlParams.get("user");
  // const userImage = `https://api.grazacacademy.com/uploads/${userDetails.means_of_identification}`;


  useEffect(() => {
    // getSingleUser(user_id)
    getSingleWeb3User(user_id)
      .then((response) => {
        // console.log(response)
        if (response.data.status === 200) {
          setUserDetails(response.data.data.result);
        } else {
          window.location.reload();
        }
      })
      // .then((res) => {
      //   console.log(res)
      //   if (res.data.status === 200) {
      //     console.log(res.data.result[0])
      //     setUserDetails(res.data.result[0]);
      //     console.log(res);
      //   } else {
      //     window.location.reload();
      //   }
      // })
      .catch((err) => {
        console.log(err.response);
        if (err.response) {
          toast.error(err.response);
        } else {
          toast.error(
            "Something went wrong!!! Please make sure you have a good internet connection."
          );
        }
      });

    // getGuarantorData(user_id)
    //   .then((res) => {
    //     console.log(res);
    //     if (res.data.status === 200) {
    //       setGuarantorDetails(res.data.data);
    //     } else {
    //       window.location.reload();
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err.response);
    //     if (err.response) {
    //       toast.error(err.response);
    //     } else {
    //       toast.error(
    //         "Something went wrong!!! Please make sure you have a good internet connection."
    //       );
    //     }
    //   });
  }, []);

  const updateStatus = (theStatus) => {
    const statusChangeFunction = () => {
      const payload = JSON.stringify({
        email: userDetails.email,
      });
      console.log(payload);
      return changeUserStatus(theStatus, payload);
    };

    const response = toast.promise(statusChangeFunction, {
      pending: `Changing user status to ${theStatus}`,
      success: "Status changed successfully.",
      error: "Unable to change user status, please try again!",
    });
    response
      .then((data) => {
        console.log(data);
        window.location.reload();
      })
      .catch((err) => console.log(err.response));
  };

  const downloadResp = (resp) => {
    setDownloadHtml(resp);
  };

  const handleRejectGuarantor1 = (id) => {
    rejectGuarantorOne(id)
    .then(res => {
      if(res.data.status === 200){
        toast.success(res.data.message)
      }
    })
    
  };
  const handleRejectGuarantor2 = (id) => {
    rejectGuarantorTwo(id)
    .then(res => {
      if(res.data.status === 200) {
        toast.success(res.data.message)
      }
    })
  }
  const handleRejectAllGuarantors = (id) => {
    rejectGuarantors(id)
    .then(res => {
      if(res.data.status === 200) {
        toast.success(res.data.message)
      }
    })
    .catch(err => {
      console.log(err)
    })

  }
  const handleApproveAllGuarantors = (id) => {
    approveGuarantors(id)
    .then(res => {
      if(res.data.status === 200) {
        toast.success(res.data.message)
      }
    })
    .catch(err => {
      console.log(err)
    })
  }
  const handleLnplStatusChange = (id) => {
    changePaymentStatus(id)
    .then(res => {
      if(res.data.status === 200) {
        toast.success(res.data.message)
      }
    })
    .catch(err => {
      console.log(err)
    })
  }

  return (
    <div>
      {/* {console.log(Object.keys(userDetails).length)} */}
      {Object.keys(userDetails).length != 0 ? (
        <div className="dashboard-content">
          <ToastContainer closeButton={false} />
          <div
            className="dashboard-content-back"
            onClick={() => window.history.back()}
          >
            <img src={arrow} alt="back" />
            <p>Back</p>
          </div>
          <div className="disp-flex dashboard-content-detail-actions">
            <div></div>
            <h3>
              {userDetails.firstName} {userDetails.lastName}
            </h3>
            <div className="disp-flex dashboard-content-actions-div">
              <ReactToPrint
                content={() => downloadHtml}
                trigger={() => <p>Download Data</p>}
              />
              {/* <img src={arrow2} alt="arrow" className="det" onClick={() => setShowDownload(true)} /> */}
              <div className="pos-rel">
                {showDownload && (
                  // <OutsideClickHandler
                  //   onOutsideClick={() => {
                  //     setShowDownload(false);
                  //   }}
                  // >
                    <div className="dashboard-content-actions-byStatus new-option">
                      <ReactToPrint
                        content={() => downloadHtml}
                        trigger={() => (
                          <div className="status">
                            <label htmlFor="under-review">Bio Data</label>
                            <img
                              src={download}
                              alt="download"
                              style={{ marginLeft: "auto" }}
                            />
                          </div>
                        )}
                      />
                      {userDetails.status != "Not Submitted" && (
                        <div>
                          <hr />
                          <ReactToPrint
                            content={() => downloadHtml}
                            trigger={() => (
                              <div className="status">
                                <label htmlFor="under-review">
                                  Educational Background
                                </label>
                                <img
                                  src={download}
                                  alt="download"
                                  style={{ marginLeft: "auto" }}
                                />
                              </div>
                            )}
                          />
                        </div>
                      )}
                      {userDetails.status === "Selected" ||
                      userDetails.status === "Admitted" ||
                      userDetails.status === "Rejected" ? (
                        <div>
                          <hr />
                          <ReactToPrint
                            content={() => downloadHtml}
                            trigger={() => (
                              <div className="status">
                                <label htmlFor="under-review">
                                  Guarantor Data
                                </label>
                                <img
                                  src={download}
                                  alt="download"
                                  style={{ marginLeft: "auto" }}
                                />
                              </div>
                            )}
                          />
                          <div style={{ height: "30px" }}></div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  // </OutsideClickHandler>
                )}
              </div>
            </div>
               {userDetails.paymentOption === "learn_now_pay_later" && (
              <div className="disp-flex dashboard-content-actions-div">
                <p className="text2" onClick={() => setChangeStatus(true)}>LNPL Status</p>
                <img
                  src={arrow3}
                  alt="arrow"
                  className="det"
                  onClick={() => setChangeStatus(true)}
                />
                <div className="pos-rel">
                  {changeStatus && (
                    // <OutsideClickHandler
                    //   onOutsideClick={() => {
                    //     setChangeStatus(false);
                    //   }}
                    // >
                      <div className="dashboard-content-actions-byStatus new-option">
                          <div>
                            <div
                              className="status"
                              onClick={() => handleLnplStatusChange(userDetails.id)}
                            >
                              <label htmlFor="reject">Reject</label>
                              <div className="radio-item">
                                <input
                                  type="radio"
                                  id="reject"
                                  name="status"
                                  value="rejected"
                                />
                                <label htmlFor="reject"></label>
                              </div>
                            </div>
                          </div>
                      </div>
                    // </OutsideClickHandler>
                  )}
                </div>  
              </div>
            ) } 

            {userDetails.paymentOption === 'learn_now_pay_later' && <div className="dashboard-content-actions-guarantorBtnContainer">
              <div><button className="" onClick={() => handleApproveAllGuarantors(userDetails.id)}>Approve Guarantors</button></div>
              <div><button className="dashboard-content-actions-guarantorBtnContainer-btn" onClick={() => handleRejectAllGuarantors(userDetails.id)}>Decline Guarantors</button></div>    
            </div>}
          </div>
          <div className="dashboard-content-detail">
            <p
              className={
                clicked === "bio"
                  ? "dashboard-content-detail-p active"
                  : "dashboard-content-detail-p"
              }
              onClick={() => setClicked("bio")}
            >
              Bio Data
            </p>
            {userDetails.paymentOption === "learn_now_pay_later" ? (
              <p
                className={
                  clicked === "guarantor"
                    ? "dashboard-content-detail-p active"
                    : "dashboard-content-detail-p"
                }
                onClick={() => setClicked("guarantor")}
              >
                Guarantor Data
              </p>
            ) : (
              <></>
            )}
          </div>
          {clicked === "bio" && (
            <div
              className="dashboard-content-form"
              ref={(response) => downloadResp(response)}
            >
              <form>
                <div className="dashboard-content-form-container">
                  <h5>Full Name</h5>
                  <p>{userDetails?.fullName}</p>
                </div>
                {/* <hr /> */}
                {/* <div className="dashboard-content-form-container">
                  <h5>Last Name</h5>
                  <p>{userDetails?.lastName}</p>
                </div> */}
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5>Email Address</h5>
                  <p>{userDetails?.email}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5>Phone Number</h5>
                  <p>{userDetails?.phoneNumber}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5>Github profile link</h5>
                  <p>{userDetails?.githubProfileLink}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5>Linkedin link</h5>
                  <p>{userDetails?.linkedInLink}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5>Twitter link</h5>
                  <p>{userDetails?.twitterLink}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5>Website/Portfolio link (optional)</h5>
                  <p>{userDetails?.portfolioLink}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5>Gender</h5>
                  <p>{userDetails?.gender}</p>
                </div>
                {/* <hr /> */}
                {/* <div className="dashboard-content-form-container">
                  <h5>Application Fee</h5>
                  <p>{userDetails?.applicationFee ? 'paid': ''}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Payment Mode</h5>
                  <p className="attachment">{userDetails?.attachment ? <a href={userDetails.attachment} target="_blank"><img src={paymentMode} alt='icon' /> {(userDetails?.attachmentName)}</a> : userDetails.coupon !== '' ? "coupon-" + userDetails?.coupon : 'Flutterwave'}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Would you prefer virtual classes or would you be physically available to come to our office (Pro Hub, Salawu Olabode Avenue, Idi Aba, Abeokuta) for 4 months to attend all your classes?. We strongly recommend on-site learning.</h5>
                  <p>{userDetails?.availability}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Our orientation and graduation is onsite. Would you make yourself available for just these two days within the 4 months of your training?</h5>
                  <p>{userDetails?.orientation}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>What inspired or motivated you to start writing codes?</h5>
                  <p>{userDetails?.inspiration}</p>
                </div> */}
                {/* <hr /> */}
                {/* <div className="dashboard-content-form-container">
                  <h5>What do you hope to achieve from this program?</h5>
                  <p>{userDetails?.achievement}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Do you have any background knowledge with JavaScript?</h5>
                  <p>{userDetails?.backgroundKnowledge}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Please specify the programming language you have worked with?</h5>
                  <p>{userDetails?.specify}</p>
                </div> */}
              </form>
            </div>
          )}
          
          
        </div>
      ) : (
        <Loader />
        //    <p>loading ooh</p>
      )}
    </div>
  );
}

export default WaitlistDetails;
